import { Link } from "react-router-dom";
import { SparkleDivider } from "@/components/site/Sparkle";

export default function NotFound() {
  return (
    <section
      data-testid="not-found-page"
      className="bg-espresso min-h-[100svh] flex items-center justify-center text-center px-6"
    >
      <div className="max-w-xl">
        <SparkleDivider light />
        <p className="font-sans uppercase tracking-[0.3em] text-[11px] text-gold mt-10">
          Error 404
        </p>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-ivory mt-6 leading-[1.05]">
          This Page Has <span className="italic text-champagne">Slipped Away</span>
        </h1>
        <p className="font-quote italic text-xl sm:text-2xl text-ivory/70 mt-6">
          The page you're looking for isn't here — but your appointment still can be.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-block mt-10 font-sans uppercase tracking-[0.2em] text-xs font-medium px-8 py-4 border border-ivory/70 text-ivory hover:bg-gold hover:border-gold hover:text-espresso transition-all duration-300"
        >
          Return to the Studio
        </Link>
      </div>
    </section>
  );
}
